import React, { Component } from 'react';
import './index.less';

export default class CardHeader extends Component {
    render() {
        const { vlicense, vbillcode } = this.props;
        return (
            <div className="card-header">
                <div className="header-left">
                    <div className="header-left-img"></div>
                    <div>{ vlicense }</div>
                </div>
                <div>派车单号：{vbillcode}</div>
            </div>
        )
    }
}
